// Socket.IO 单例客户端
// 生产环境由 Nginx 把 /realtime/socket.io 反代到 Express
// 开发环境由 next.config.ts rewrites 代理
// R26：token 已是 HttpOnly cookie，JS 读不到；用 withCredentials:true 让
// 握手时自动带上 Cookie header，后端 realtime.js 从 cookie 兜底解析 token。
import { io, type Socket } from "socket.io-client";

let socket: Socket | null = null;
let listeners = 0;
let visibilityHooked = false;

export function getSocket(): Socket {
  if (socket && socket.connected) return socket;
  if (socket) return socket; // 正在连接中

  socket = io({
    path: "/realtime/socket.io",
    transports: ["websocket", "polling"],
    withCredentials: true,
    reconnection: true,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 5000,
  });

  socket.on("connect_error", (err) => {
    console.error("[socket] connect_error:", err.message);
  });

  // Safari 后台 tab 会主动挂起 WebSocket 并打 "WebSocket is closed due to suspension"
  // warning。我们在页面隐藏时主动 disconnect、可见时重连，避开这个 warning，
  // 同时省掉无意义的后台心跳。
  if (typeof document !== "undefined" && !visibilityHooked) {
    visibilityHooked = true;
    document.addEventListener("visibilitychange", () => {
      if (!socket) return;
      if (document.visibilityState === "hidden") {
        try { socket.disconnect(); } catch { /* ignore */ }
      } else if (listeners > 0 && !socket.connected) {
        try { socket.connect(); } catch { /* ignore */ }
      }
    });
  }

  return socket;
}

export function releaseSocket() {
  listeners = Math.max(0, listeners - 1);
  if (listeners === 0 && socket) {
    socket.disconnect();
    socket = null;
  }
}

export function retainSocket() {
  listeners += 1;
  return getSocket();
}

/** 强制断开并清空（用于 401 后阻断 Realtime → invalidate → refetch 的循环） */
export function forceDisconnectSocket() {
  if (socket) {
    socket.removeAllListeners();
    socket.disconnect();
    socket = null;
  }
  listeners = 0;
}
